<template>
  <section>
  <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" :visible.sync="loginVisible" label-position="left" label-width="0px" 
           class="demo-ruleForm login-container grijs" style='width:280px'>
    
    <h3 style='margin-bottom:45px;margin-top:0;color:#409EFF'>
		  <span><img style='float:left;height:55px;xwidth:50px;margin-top:-5px;border-radius:4px' src='../../static/img/tui-main.png' /></span>
     <span style='float:right'>WRD Service App</span><br/>
      <span v-if='loginMode<2' style='float:right'>Login <span class="special">{{this.stage}}</span></span>
      <span v-else :class="stageClass" style='float:right'>Tui WRD</span>
    </h3>		
    
    <span v-if="loginMode!=2">
  		<el-form-item prop="account">
        <el-input type="text" ref='account' autofocus v-model="ruleForm2.account" auto-complete="off" placeholder="Your Logincode"></el-input>
      </el-form-item>
    
  		<el-form-item prop="checkPass">
        <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="and password"  @keyup.enter.native="handleSubmit2" show-password></el-input>
      </el-form-item>
    
		  <el-form-item style="width:100%;margin-top:20px">
        <el-button type="primary" style="width:100%;" 
  			@click.native.prevent="handleSubmit2" :loading="logining">Login</el-button>
	  	</el-form-item>
 
     <el-form-item v-if="loginMode!=2">
        <el-button type="text" style="margin-top:-10px;float:right" @click.native.prevent="resetPassword" :loading="logining" show-password>Reset Password</el-button>
		  </el-form-item>
    </span>
    <span v-else>
      <center  style='margin-bottom:20px'>
      <el-button type="primary" style="width:100%;" 
  			@click.native.prevent="handleSubmit2" :loading="logining">Start Application</el-button>
	    </center>
    </span>
 
    <font style='font-size:9px;font-family:verdana'><center>&copy;2022 Tui-WRD. Created by Ruud Noordermeer </center></font>
  </el-form>

	
    <el-dialog title="Reset your Password" :visible.sync="resetVisible" width="300px">
       <el-form :model="resetForm" label-width="60px" ref="resetForm" style='margin-top:20px'>
        <el-form-item label="Email :" prop="deptemail">
					<el-input v-model="resetForm['email']" auto-complete="off"></el-input>
				</el-form-item>
       <el-col>
       <div style='font-size:13px;margin-left:60px;margin-bottom:20px'>
         NOTE: THIS FUNCTION IS NOT YET AVAILABLE!!<br><br>
         After pressing the 'Reset' button we will send you an email<br>with further instructions.
	     </div>
        </el-col>
   
			</el-form>

			<div slot="footer" class="dialog-footer">		  
				<el-button size='small' icon="el-icon-upload2"  @click.native="resetVisible = false">Cancel</el-button>
				<el-button :disabled="isEmailInvalid(resetForm['email'])" size='small' type="primary" icon="el-icon-edit"  @click.native="resetSubmit">Reset</el-button>
			</div>
		</el-dialog>
  
  </section>

</template>

<script>
  import api      from '../api/login';
 	import util     from '../common/AppUtil';
	
  export default {
    data() {
      return {
        QID         : util.Initialize(this.$router,"*"),
        util        : util,
        logining: false,
        loginMode: 1,  // 0/1=yes 2=no
        stage: "",
        stageClass: "dev",
        resetVisible: false,
        loginVisible: true,
        resetForm: {email: ""},

        ruleForm2: {
          account: '',
          checkPass: '',
					//apiserver: window.apiserver
        },
        rules2: {
          account: [
            { required: true, message: 'Your logincode is required', trigger: 'blur' },
            //{ validator: validaePass }
          ],
          checkPass: [
            { required: true, message: 'Enter your password', trigger: 'blur' },
            //{ validator: validaePass2 }
          ]
        },
        checked: true
      };
    },
    methods: {
      
      isEmailInvalid(email) {
        var re = /\S+@\S+\.\S+/;
        return ! re.test(email);
     },

      resetPassword() {
        this.resetVisible = true;
      },
      
      resetSubmit() {
	       if (this.resetForm.email != '')
			  {		
           let parg = [];
           parg["email"] = this.resetForm.email;
           api.resetLogin(parg).then(response => {
             
             this.resetVisible = false;
             this.$message({
 			     	   title: "Reset Request has been send",type: 'success',
               duration: 8000,
               dangerouslyUseHTMLString: true,
   			  	   message: "<div style='font-height:16px;line-height:30px;margin:10px'>If you are an active user on our system you will receive an email<br> with further instructions. Check your inbox (do not forget your spambox).</div>"
     		  	 });
           });
        
           this.resetVisible = false;
         }
      },

      setFocus: function() {
        // Note, you need to add a ref="search" attribute to your input.
        if (this.loginMode < 2)
          this.$refs.account.focus();
      },

      handleSubmit2(ev) {
        var _this = this;
				var _user = {Status: false};

        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            this.logining = true;
    				let parg = {};
            parg.Params = {};
            parg.Module = "Login";
            parg.Action = "login";
            parg.Params.username = this.ruleForm2.account;
            parg.Params.password = this.ruleForm2.checkPass;

            api.requestLogin(parg).then(response => {

   						this.logining = false;	

              var userRequest = response.data;
              if (typeof(userRequest) === "string") userRequest = JSON.parse(response.data);   // convert aws string to 

              if (userRequest.header.OK == true) _user = userRequest.payload.user;

              var isOK = _user.Status == "OK";
							if (isOK)
							{
              	sessionStorage.setItem('token',_user.Token);
	  	      		sessionStorage.setItem('name',_user.Name);
                sessionStorage.setItem('avatar',"./static/" + _user.Avatar);
				        sessionStorage.setItem('login',_user.Code);
                sessionStorage.setItem('roles',_user.Roles);
                sessionStorage.setItem('depts',_user.Departments);

                window.localStorage.setItem("selgroup","");
                
                if(_user.pwdreset == 1)
                  this.$router.push('/profile');
                else this.$router.push({ path: '/' });
              }
							else {
       
                sessionStorage.setItem('name',"");
				        sessionStorage.setItem('avatar',"./static/users/p1.png");
                sessionStorage.setItem("userLevel","0");
             		sessionStorage.setItem('token',"");							  
                sessionStorage.setItem('roles',"");
                sessionStorage.setItem('depts',"");

								this.$message({
                  message: userRequest.header.message,
                  duration: 8000,
                  type: 'error'
                });
                this.setFocus();
							}
              
            });
          } 
					else {
            this.setFocus();
            return false;
          }
        });
      }
    },

    created() {
        setTimeout(x => {
           this.$nextTick(() => this.setFocus()); // this works great, just watch out with going to fast !!!
        }, 1000);
    },

		mounted() {
        console.log("INIT LOGIN");
       //this.apiserver = window.apiserver;
       //this.loginMode = server.ApiLoginMode;
       if (window.sessionStorage.getItem("force") == 1) {
          window.sessionStorage.removeItem("force");
          this.loginMode = 1;
       }
       this.stage = (window.stage == 'prd' ? "" : window.stage.toUpperCase());
    },
  }

</script>

<style lang="scss" scoped>

	.login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 25px 5px;
    }
  }
  .grijs { background-color:#ebf4ff !important; }

  .special {color:orange}

</style>


// WEBPACK FOOTER //
// Login.vue?d6d36258